import React, { useContext, useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingFilters } from "../hooks/useOnPremOrderListingFilters";

export interface ExportOnPremOrdersButtonProps {
    filters: OnPremOrderListingFilters;
}

export const ExportOnPremOrdersButton: React.FC<ExportOnPremOrdersButtonProps> = ({
    filters
}: ExportOnPremOrdersButtonProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { pinnedItems } = useContext(OnPremOrderListingContext);

    const { exportOnPremOrders } = useOrdersModuleApi();

    const handleClick = async () => {
        setIsLoading(true);

        exportOnPremOrders({
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            statuses: filters.statuses,
            content: filters.content,
            pONumber: filters.pONumber,
            distributorId: filters.distributorId,
            airlineIds: filters.airlineIds,
            systemIds: filters.systemIds,
            orderIds: pinnedItems,
            dueDateFrom: filters.dueDateFrom?.toISOString(),
            dueDateTo: filters.dueDateTo?.toISOString()
        })
            .then(({ fileUrl }) => {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "onPremOrdersFile");
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return <CommandBarButton onClick={handleClick} text="Export" icon="Generate" isLoading={isLoading} />;
};
